import AdminRoutes from './AdminRoutes'
import InternalUserRoutes from './InternalUserRoutes'
const privateRoutes = [...AdminRoutes, ...InternalUserRoutes]

export default privateRoutes
